import type { ReactNode } from "react";
import { Headline, Text } from "../components";

export const NotFoundPage = ({ button }: { button?: ReactNode }) => (
  <div className="flex h-screen w-full flex-col items-center justify-center gap-8">
    <Headline size="5xl" className="text-primary-100">
      404
    </Headline>
    <Text size="xl">Oops, we couldn&apos;t find this page...</Text>
    {button}
  </div>
);
